export default "__VITE_ASSET__Del$DsOr__"